import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { DistrictService } from '../../services/district.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule, JsonPipe } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { ValidationService } from '../../services/validation.service';
import { TableDropdownComponent } from '../../components/table-dropdown/table-dropdown.component';

@Component({
  selector: 'app-payment-history',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ModalComponent, ReactiveFormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, SearchInputComponent,],
  templateUrl: './payment-history.component.html',
  styleUrl: './payment-history.component.css'
})
export class PaymentHistoryComponent {
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  page_name = 'Payment History';
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];

  columns: any = [];

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DistrictService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService) { }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['university', 'assessment', 'head_evaluator']);

    this.columns = [
      { field: 'State.country.name', headerName: 'Academic Year', filter: true, flex: 1, },
      { field: '', headerName: 'Program', filter: true, flex: 1, },
      { field: '', headerName: 'Exam', filter: true, flex: 1, },
      { field: '', headerName: 'Subject', filter: true, flex: 1, },
      { field: '', headerName: 'Payment Date', filter: true, flex: 1, },
      { field: '', headerName: 'Payment Status', filter: true, flex: 1, },
      { headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
    ];
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: 'bx bx-arrow-to-bottom' })
    return actions
  }


  async get_list(filter?: any) {
    try {
      const res = await this.ds.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;
      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

}
